import { wait } from '@/__mocks__/util/async.ts'
import { status } from '@/__mocks__/config.ts'
import { banksPage } from '@/__mocks__/modules/banks/data.ts'

export default [
  {
    method: 'GET',
    path: '/bank',
    reply: async () => {
      await wait()
      return [status.ok, banksPage]
    }
  }
]
